import Switch from '@eduzz/houston-ui/Forms/Switch';
import { FormHelperText, Grid, MenuItem, TextField } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { constants } from 'helpers/constants';
import { EChargeType } from 'interfaces/IEditProduct';
import { EPartnerCode } from 'interfaces/IProduct';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { run } from 'validations/ruleRunner';

import type { User } from 'v2/interfaces/user';

import { FormContent } from '../FormContent';
import styles from '../styles';
import BlockedFieldTooltipProps from './../General/blockedTooltipProps';
import SinglePayment from './components/SinglePayment';
import Subscription from './components/Subscription';
import Validations from './validations';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends IPropsFromConnect, DispatchProp<any>, StyledComponentProps {
  loading: boolean;
  fade?: any;
  offer?: IProduct;
  modifieds?: any[];
  editing?: any;
  handleChange?: any;
  copyFromOriginal?: any;
  currencyList: any;
  onChangeRequiredFields?: any;
  classes?: any;
}

interface IPropsFromConnect {
  currentUser: User;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  singlePaymentErrors: any;
  subscriptionErrors: any;
}

class Sale extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.offer, Validations),
      singlePaymentErrors: {},
      subscriptionErrors: {},
    };
  }
  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  onChangeRequired = (name: string, fields: any) => {
    let newState = this.state;
    newState[name] = fields;
    this.setState(newState);
  };

  onChangeStates = () => {
    let { offer, onChangeRequiredFields } = this.props;
    const { singlePaymentErrors, subscriptionErrors } = this.state;
    let newValidations = this.state.validationErrors;
    if (offer.charge_type === EChargeType.SINGLE) {
      newValidations = { ...singlePaymentErrors, ...run(offer, Validations) };
    } else if (offer.charge_type === EChargeType.SUBSCRIPTION) {
      newValidations = { ...subscriptionErrors, ...run(offer, Validations) };
    } else {
      newValidations = { ...run(offer, Validations) };
    }
    this.setState({ validationErrors: newValidations });
    if (onChangeRequiredFields) {
      onChangeRequiredFields('salesRequiredFields', newValidations ? Object.keys(newValidations).length : 0);
    }
  };

  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.offer !== prevProps.offer) {
      this.onChangeStates();
    }
  }
  componentDidMount() {
    if (!this.props.loading) {
      this.onChangeStates();
    }
  }
  render() {
    const { loading, handleChange, offer, modifieds, editing, classes, currencyList, currentUser } = this.props;

    const isAlumy = offer.cnt_partner_cod === EPartnerCode.ALUMY;
    const isBlinket = offer.cnt_partner_cod === EPartnerCode.BLINKET;
    const isUnity = !!currentUser?.is_clube_black;
    const itsInfoEvent = offer.type === constants.INFO || offer.type === constants.TICKET;
    const itsSinglePayment = offer.charge_type === EChargeType.SINGLE;
    const itsOpenValuePayment = offer?.charge_type === EChargeType.OTHER;
    const itsSubscriptionPayment = offer.charge_type === EChargeType.SUBSCRIPTION;

    return (
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12}>
          <FormContent title='Formas de cobrança' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <BlockedFieldTooltipProps
                  product={offer}
                  enabled={isAlumy || isBlinket}
                  title={isAlumy ? 'Produto do tipo Alumy não pode ser alterado o tipo de cobrança' : null}
                >
                  <TextField
                    id='charge_type'
                    select
                    fullWidth
                    value={offer.charge_type}
                    onChange={(e: any) => {
                      if (e.target.value === EChargeType.OTHER) {
                        handleChange('recovery_email', '');
                        handleChange('sales_recovery', false);
                        handleChange('recruit_commission_type', 'P');
                        handleChange('comission_type', 'P');
                      }
                      if (e.target.value !== EChargeType.SUBSCRIPTION) {
                        handleChange('trial', false);
                      }

                      if (e.target.value !== EChargeType.SINGLE) {
                        handleChange('interest_free_installment', false);
                      }

                      if (e.target.value === 'A') {
                        handleChange('recurring_frequency', 1);
                      }

                      handleChange('charge_type', e.target.value);
                    }}
                    label='Tipo de cobrança'
                    helperText='Única, Assinatura ou Gratuito'
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isAlumy || isBlinket}
                  >
                    <MenuItem value={EChargeType.SINGLE}>Única</MenuItem>
                    {(offer.type === constants.INFO ||
                      offer.type === constants.JOBZZ ||
                      (offer.type === constants.PHYSICAL && currentUser.subscription_physical)) && (
                      <MenuItem value={EChargeType.SUBSCRIPTION}>Assinatura/Recorrência</MenuItem>
                    )}
                    {(offer.type === constants.INFO || offer.type === constants.JOBZZ) && <MenuItem value={EChargeType.OTHER}>Valor Aberto</MenuItem>}
                    {offer.type !== 3 && <MenuItem value={EChargeType.FREE}>Gratuito</MenuItem>}
                  </TextField>
                </BlockedFieldTooltipProps>
              </Grid>

              {offer.charge_type !== EChargeType.FREE && offer.charge_type !== EChargeType.OTHER && (
                <Grid item xs={12}>
                  <BlockedFieldTooltipProps product={offer} enabled={isAlumy || isBlinket}>
                    <TextField
                      id='currency_type'
                      select
                      fullWidth
                      value={offer.currency_id}
                      onChange={(value: any) => handleChange('currency_id', value.target.value)}
                      label='Moeda'
                      helperText='Moeda que o produto será vendido'
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={isAlumy || isBlinket}
                    >
                      {currencyList &&
                        currencyList.length &&
                        currencyList.map((curr: any) => (
                          <MenuItem key={`curr-${curr.code}`} value={curr.id} disabled={curr.code !== 'BRL'}>
                            {curr.code} - {curr.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </BlockedFieldTooltipProps>
                </Grid>
              )}

              {offer.charge_type === EChargeType.SINGLE && (
                <SinglePayment offer={offer} handleChange={handleChange} onChangeRequiredFields={this.onChangeRequired} loading={loading} />
              )}
              {offer.charge_type === EChargeType.SUBSCRIPTION && (
                <Subscription
                  offer={offer}
                  handleChange={handleChange}
                  onChangeRequiredFields={this.onChangeRequired}
                  modifieds={modifieds}
                  editing={editing}
                  loading={loading}
                  isAlumy={isAlumy}
                />
              )}
              {offer.charge_type === EChargeType.OTHER && (
                <Grid item xs={12}>
                  <p>
                    O valor <strong>minímo</strong> no checkout será de R$ 5,00
                  </p>
                  <p>Não será habilitado o parcelamento no checkout</p>
                </Grid>
              )}
              {offer.charge_type === EChargeType.FREE && (
                <>
                  <Grid item xs={12} md={2}>
                    <div>
                      <img src='/img/eduzzinho-thumbsup.png' alt='Eduzzinho' width='100px' style={{ marginRight: '50px' }} />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <b>Eba! Produto gratuito.</b>
                    <p>Produto gratuito é uma ótima maneira de captar leads, você pode utilizar como produto de entrada para outro produto pago.</p>
                  </Grid>
                </>
              )}
            </Grid>
          </FormContent>
        </Grid>

        {offer.charge_type !== EChargeType.FREE && (
          <Grid item xs={12}>
            <FormContent title='Meios de pagamento e checkout' loading={loading}>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={12}>
                  <Switch
                    value={offer.allows_boleto}
                    onChange={(bool: boolean) => handleChange('allows_boleto', bool)}
                    disabled={isAlumy || offer.trial}
                  >
                    Permitir boleto
                  </Switch>

                  {this.isValid('allows_payment_types') ? (
                    <FormHelperText style={{ color: 'red' }}>{this.errorFor('allows_payment_types')}</FormHelperText>
                  ) : (
                    <FormHelperText>Permitir geração de boleto no checkout?</FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Switch disabled={isAlumy} value={offer.allows_card} onChange={(bool: boolean) => handleChange('allows_card', bool)}>
                    Permitir cartão
                  </Switch>
                  {this.isValid('allows_payment_types') ? (
                    <FormHelperText style={{ color: 'red' }}>{this.errorFor('allows_payment_types')}</FormHelperText>
                  ) : (
                    <FormHelperText>Permitir pagamento com cartão no checkout?</FormHelperText>
                  )}
                </Grid>
                {offer.charge_type !== EChargeType.SUBSCRIPTION && (
                  <Grid item xs={12}>
                    <Switch value={offer.allows_paypal} disabled={isAlumy} onChange={(bool: boolean) => handleChange('allows_paypal', bool)}>
                      Permitir PayPal
                    </Switch>

                    {this.isValid('allows_payment_types') ? (
                      <FormHelperText style={{ color: 'red' }}>{this.errorFor('allows_payment_types')}</FormHelperText>
                    ) : (
                      <FormHelperText>Permitir pagamento com paypal no checkout?</FormHelperText>
                    )}
                  </Grid>
                )}

                {(itsSinglePayment || itsSubscriptionPayment || itsOpenValuePayment) && (
                  <Grid item xs={12}>
                    <Switch value={offer.allows_pix} onChange={(bool: boolean) => handleChange('allows_pix', bool)}>
                      Permitir Pix
                    </Switch>

                    {this.isValid('allows_payment_types') ? (
                      <FormHelperText style={{ color: 'red' }}>{this.errorFor('allows_payment_types')}</FormHelperText>
                    ) : (
                      <FormHelperText>Permitir pagamento com pix no checkout?</FormHelperText>
                    )}
                  </Grid>
                )}
                {isUnity && itsInfoEvent && (
                  <Grid item xs={12}>
                    <Switch value={offer.allows_eduzz_balance} onChange={(bool: boolean) => handleChange('allows_eduzz_balance', bool)}>
                      Saldo Eduzz
                    </Switch>
                    <FormHelperText>
                      Permitir pagamentos com Saldo Eduzz no checkout?{' '}
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://ajuda.eduzz.com/hc/pt-br/articles/4406136094107-Como-pagar-uma-compra-com-saldo-dispon%C3%ADvel-para-transfer%C3%AAncia-pelo-Eduzz-Pay-Beta-'
                      >
                        Saiba mais
                      </a>
                    </FormHelperText>
                  </Grid>
                )}
                {offer.charge_type === EChargeType.SUBSCRIPTION && (
                  <Grid item xs={12}>
                    <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
                      <div>
                        <Switch
                          value={offer.deliver_first_charge}
                          onChange={(bool: boolean) => handleChange('deliver_first_charge', bool)}
                          disabled={isAlumy}
                        >
                          Entregar conteúdo apenas na primeira cobrança paga
                        </Switch>
                        <FormHelperText>
                          O cliente receberá a entrega do conteúdo apenas uma vez, ao realizar o pagamento da adesão ou da primeira cobrança.
                        </FormHelperText>
                      </div>
                    </BlockedFieldTooltipProps>
                  </Grid>
                )}
                {offer.charge_type !== EChargeType.FREE && offer.charge_type !== EChargeType.OTHER && (
                  <Grid item xs={12}>
                    <Switch value={offer.interest_free_installment} onChange={(bool: boolean) => handleChange('interest_free_installment', bool)}>
                      Parcelamento sem juros
                    </Switch>
                    <FormHelperText>
                      As parcelas no checkout irão aparecer sem os juros. Nesse caso o produtor assume os juros no lugar do comprador.{' '}
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807551369-O-que-%C3%A9-Parcelamento-sem-juros-'
                      >
                        Saiba Mais
                      </a>
                    </FormHelperText>
                  </Grid>
                )}
                {![constants.PHYSICAL, constants.TICKET].includes(offer.type) && offer.charge_type === EChargeType.SINGLE && (
                  <Grid item xs={12}>
                    <Switch value={offer.unlimited_installment} onChange={(bool: boolean) => handleChange('unlimited_installment', bool)}>
                      Parcelamento sem limites
                    </Switch>

                    <FormHelperText>
                      Caso o seu cliente não tenha limite no cartão você pode oferecer o pagamento em parcelas recorrentes. Elas são cobradas
                      mensalmente e sem comprometer o limite de crédito do comprador.{' '}
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807548029-Parcelamento-Sem-Limites'
                      >
                        Saiba Mais
                      </a>
                    </FormHelperText>
                  </Grid>
                )}
                {offer.unlimited_installment && offer.charge_type === EChargeType.SINGLE && (
                  <Grid item xs={12}>
                    <div>
                      <Switch
                        value={offer.deliver_first_charge}
                        onChange={(bool: boolean) => handleChange('deliver_first_charge', bool)}
                        disabled={isAlumy}
                      >
                        Entregar conteúdo apenas na primeira cobrança paga
                      </Switch>
                      <FormHelperText>
                        O cliente receberá a entrega apenas uma vez, ao realizar o pagamento da primeira cobrança do parcelamento sem limites.
                      </FormHelperText>
                    </div>
                  </Grid>
                )}

                {offer.charge_type !== EChargeType.SUBSCRIPTION && (
                  <Grid item xs={12}>
                    <Switch
                      value={offer.allows_multiple_cards}
                      disabled={isAlumy}
                      onChange={(bool: boolean) => handleChange('allows_multiple_cards', bool)}
                    >
                      Permitir múltiplos cartões
                    </Switch>
                    {this.isValid('allows_payment_types') ? (
                      <FormHelperText style={{ color: 'red' }}>{this.errorFor('allows_payment_types')}</FormHelperText>
                    ) : (
                      <FormHelperText>Permitir pagamento com dois ou mais cartões no checkout?</FormHelperText>
                    )}
                  </Grid>
                )}
              </Grid>
            </FormContent>
          </Grid>
        )}

        <Grid item xs={12}>
          <FormContent title='Recuperação de vendas' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <Tooltip
                  title={offer.charge_type === EChargeType.OTHER ? '*Não é possível ativar a recuperação com Valor Aberto' : ''}
                  placement='top'
                >
                  <Switch
                    disabled={offer.charge_type === 'L' || isAlumy}
                    value={offer.sales_recovery}
                    onChange={(bool: boolean) => {
                      if (bool === false) {
                        offer.recovery_email = '';
                        handleChange('recovery_email', '');
                      }

                      return handleChange('sales_recovery', bool);
                    }}
                  >
                    Recuperar vendas perdidas
                  </Switch>
                </Tooltip>
                <FormHelperText>
                  A Eduzz tentará recuperar vendas não concretizadas.{' '}
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-Como-funciona-a-recupera%C3%A7%C3%A3o-de-vendas-perdidas-RVP-'
                  >
                    Saiba Mais
                  </a>
                </FormHelperText>
              </Grid>
              {offer.sales_recovery && (
                <Grid item xs={12}>
                  <Tooltip title={'O nome definido neste campo aparecerá como remetente nos e-mails enviados de Recuperação de Vendas.'}>
                    <TextField
                      className={classes.input}
                      label='Nome do remetente de e-mail para recuperação de vendas'
                      id='recovery_email'
                      helperText={this.isValid('recovery_email') ? this.errorFor('recovery_email') : 'Ex: Fulano da Silva - Eduzz'}
                      error={this.isValid('recovery_email')}
                      fullWidth
                      value={offer.recovery_email}
                      onChange={(e: any) => handleChange('recovery_email', e.target.value)}
                      disabled={!offer.sales_recovery}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // disabled={isAlumy}
                    />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </FormContent>
        </Grid>
      </Grid>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    currentUser: state.orbita.User.user.user,
  };
}

export default connect(mapStateToProps)(styles(Sale));
